"use client"

import { useRouter } from "next/navigation";

function PrimaryButton({ text, link, className, onClick }) {
  const router = useRouter();

  const handleClick = (event) => {
    if (onClick) onClick(event);
    if (link) router.push(link);
  };

  return (
    <button
      onClick={handleClick} // Use the new handleClick function
      className={`bg-primary cursor-pointer text-white rounded-lg text-sm md:text-lg px-6 md:px-8 py-2
       hover:bg-faded ${className}`}
      type="button"
      aria-label={text}
    >
      {text}
    </button>
  );
}

export default PrimaryButton;
